import React from 'react';
import {withFormsy} from 'formsy-react';
import {Tooltip} from '@material-ui/core';
import _ from '@lodash';
import * as R from 'ramda';
import clsx from 'clsx';

function DefaultSwitchFormsy(props) {
  const importedProps = _.pick(props, [
    'checkedIcon',
    'classes',
    'color',
    'disabled',
    'disableRipple',
    'icon',
    'id',
    'indeterminate',
    'indeterminateIcon',
    'inputProps',
    'inputRef',
    'onChange',
    'variant'
  ]);
  
  // An error message is returned only if the component is invalid
  const value = props.value;

  function changeValue(event) {
    props.setValue(event.target.checked);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  let inputElem = <label className="switch-checkbox-wrapper">
    <input
      {...importedProps}
      ref={importedProps.inputRef}
      className="switch-checkbox"
      type='checkbox'
      checked={value}
      onChange={changeValue}
    />
    <span className={clsx("switch-slider", props.disabled && 'bg-gray-400 disabled')}/>
  </label>;

  const tooltipElm = value || R.isNil(props.tooltipText) ? inputElem : (
    <Tooltip
      title={props.tooltipText}
      placement="top-start"
    >
      {inputElem}
    </Tooltip>
  )

  return (
    <div className={clsx(props.className,"cs-switch")}>
      {!props.labelRight && (
        <>
          <div className="switch-label text-style-one">{props.label}</div>
          {tooltipElm}
        </>
      )}
      {props.labelRight && (
        <>
          <div className="mr-8">{tooltipElm}</div>
          <div className="text-style-one">{props.label}</div>
        </>
      )}
    </div>
  );
}

export default React.memo(withFormsy(DefaultSwitchFormsy));